
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommunicationSendMessageApi } from '../api/communicationsendmessage.api';
import { switchMap, map } from 'rxjs/operators';

import { CommunicationSendMessageData, CommunicationSendMessage } from '../../../interfaces/masters/communicationsendmessage' ;
@Injectable()
export class CommunicationSendMessageService extends CommunicationSendMessageData {

    constructor(private api: CommunicationSendMessageApi) {
      super();
    }
  
  
    list(url: string): Observable<CommunicationSendMessage[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<CommunicationSendMessage>{
        return this.api.getById(url);
    }
  
    create(url: string, data:CommunicationSendMessage): Observable<CommunicationSendMessage[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:CommunicationSendMessage): Observable<CommunicationSendMessage> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  